import script from "./ModalBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBlock.vue?vue&type=script&setup=true&lang=js"

import "./ModalBlock.vue?vue&type=style&index=0&id=5488bb42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5488bb42"]])

export default __exports__